---
title: "Built to Thrive: Using Innovation to Make Your Mark in a Connected World"
slug: built-to-thrive
type: book
status: published
featured: true
summary: Unpacking the drivers in a connected landscape that did not yet have a place in our vocabulary — shared value-creation, ideation, and knowledge dissemination.
sitePublishedAt: "2026-09-18"
originalPublishedAt: "2011-01-01"
lastReviewedAt: "2026-09-18"
audiences:
  - business
  - product-developer
themes:
  - innovation-systems
  - computational-social-science
sourceUrl: https://www.amazon.com/Built-Thrive-Using-Innovation-Connected/dp/1447856104
originalAuthor: Jay van Zyl
sourceRelationship: first-party authored book
rightsStatus: first-party
seoDescription: Built to Thrive (2011) by Jay van Zyl, with a Custom GPT companion for the world of AI.
canonicalPath: /resources/built-to-thrive
isbn: "9781447856104"
year: 2011
---

Jay van Zyl, 2011. Lulu / Amazon. Eric Hoffer Award category finalist (site listing: 2012).

> Built to Thrive is about unpacking the drivers that I have noticed in the landscape that do not yet have a place in our existing vocabulary. The individual becomes the collective as we move into a sphere of shared value-creation, ideation and knowledge dissemination. Existing in this new business landscape is not about eliminating the competition, but rather working together in a bid to share resources and expand far beyond what we could ever hope to achieve as individual organizations.

- [Lulu](http://www.lulu.com/shop/jay-van-zyl/built-to-thrive-using-innovation-to-make-your-mark-in-a-connected-world/paperback/product-18664864.html)
- [Amazon](https://www.amazon.com/Built-Thrive-Using-Innovation-Connected/dp/1447856104)
- Custom GPT: [Built to Thrive in the World of AI](https://chatgpt.com/g/g-ZS1LEEzIv-built-to-thrive-in-the-world-of-ai)
